import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { CoachModal } from '@/features/coach/components/CoachModal';
import type { ResourceReadScope, ResourceUsage } from '@/lib/types';
import { useResourceUses } from './useResourceLibrary';

export function ResourceUsesModal({ scope, resourceId, onClose, onOpen, returnFocusTo }: {
  scope: ResourceReadScope; resourceId: string; onClose(): void; onOpen?(usage: ResourceUsage): void; returnFocusTo?: HTMLElement | null;
}) {
  const [cursors, setCursors] = useState<(string | undefined)[]>([undefined]);
  const query = useResourceUses(scope, resourceId, { publication: 'all', limit: 20, cursor: cursors.at(-1) });
  const page = query.admitted;
  return <CoachModal title="Visible uses" description="Only published Feedback and your saved drafts are included." onClose={onClose} returnFocusTo={returnFocusTo}>
    {!query.active || query.isError ? <div role="alert"><p>Visible uses could not be loaded.</p>{query.active && <Button variant="outline" onClick={() => { if (cursors.length > 1) setCursors([undefined]); else void query.refetch(); }}>Reload visible uses</Button>}</div>
      : !page ? <p role="status">Loading visible uses…</p> : <>
        {!page.items.length && <p>No uses visible to you.</p>}
        <ul className="space-y-3">{page.items.map(use => <li key={`${use.feedback_id}:${use.ordinal}`} className="border-b border-rule pb-3">
          <p className="font-semibold">{use.availability === 'available' ? use.message_excerpt : 'Feedback unavailable'}</p>
          <p className="text-xs text-ink-muted">{use.publication_state === 'draft' ? 'Your private draft' : 'Published Feedback'}</p>
          {onOpen && use.availability === 'available' && <Button variant="ghost" size="sm" onClick={() => onOpen(use)}>Open Feedback</Button>}
        </li>)}</ul>
        {(page.total > 20 || cursors.length > 1) && <div className="mt-3 flex items-center justify-between gap-2 text-xs">
          <span>{page.range_start}–{page.range_end} of {page.total} visible uses</span>
          <Button variant="ghost" disabled={cursors.length === 1} onClick={() => setCursors(value => value.slice(0, -1))}>Previous</Button>
          <Button variant="ghost" disabled={!page.next_cursor} onClick={() => setCursors(value => [...value, page.next_cursor!])}>Next</Button>
        </div>}
      </>}
  </CoachModal>;
}
